import { createSlice } from "@reduxjs/toolkit";
import {
  addBranch,
  deleteBranch,
  getAllBranches,
  getBranchDetails,
  getBranchList,
  getBranchListByCity,
  getBranchListWithCity,
  syncLocks,
  updateBranch,
  updateBranchStatus,
} from "store/actions/branchSlice";

const initialState = {
  isLoading: false,
  loading: false,
  perPage: 12,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  branches: [],
  drafts: [],
  branchDetails: {},
  branchesByCity: [],
  branchesWithCity: [],
  branchesList: [],
  branchesFilters: {
    keyword: "",
    dates: [],
    selectedFilters: {
      status: -1,
      orderBy: -1,
      organizationId: "",
    },
  },
};

const branchSlice = createSlice({
  name: "branch",
  initialState,
  reducers: {
    updateBranchesFilterState: (state, action) => {
      state.branchesFilters = {
        ...state.branchesFilters,
        ...action.payload,
      };
    },
    resetBranchesFilterState: (state) => {
      state.branchesFilters = initialState.branchesFilters;
    },
    // You can define additional synchronous actions here if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllBranches.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllBranches.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } =
            action.payload || {};
          const branches = [];
          const drafts = [];

          if (data?.length > 0) {
            data.forEach((item) => {
              if (item.status === 1) {
                branches.push(item);
              } else if (item.status === 3) {
                drafts.push(item);
              }
            });
          }

          state.branches = branches || [];
          state.drafts = drafts || [];
          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getAllBranches.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(getBranchDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBranchDetails.fulfilled, (state, action) => {
        state.loading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.branchDetails = data;
        }
      })
      .addCase(getBranchDetails.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(addBranch.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addBranch.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(addBranch.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateBranch.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateBranch.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateBranch.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(deleteBranch.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteBranch.fulfilled, (state, action) => {
        const { success } = action.payload;
        const { id } = action.meta.arg;
        state.isLoading = false;
        if (success) {
          state.branches = state.branches.filter((item) => item._id !== id);
          state.drafts = state.drafts.filter((item) => item._id !== id);
          if (state.totalCount !== null) {
            state.totalCount -= 1;
          }
        }
      })
      .addCase(deleteBranch.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateBranchStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateBranchStatus.fulfilled, (state, action) => {
        const { success, data } = action.payload || {};
        const { id, status: updatedStatus } = action.meta.arg;
        state.isLoading = false;
        if (success) {
          if (updatedStatus === 1) {
            // Remove from drafts and append to branches
            state.drafts = state.drafts.filter((item) => item._id !== id);
            state.branches.push(data);
          } else if (updatedStatus === 3) {
            // Remove from workspaces and append to drafts
            state.branches = state.branches.filter((item) => item._id !== id);
            state.drafts.push(data);
          }
        }
      })
      .addCase(updateBranchStatus.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getBranchListByCity.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBranchListByCity.fulfilled, (state, action) => {
        state.isLoading = false;
        const { success, data } = action.payload || {};
        if (success) {
          state.branchesByCity = data;
        }
      })
      .addCase(getBranchListByCity.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(getBranchListWithCity.pending, (state) => {})
      .addCase(getBranchListWithCity.fulfilled, (state, action) => {
        const { success, data } = action.payload || {};
        if (success) {
          state.branchesWithCity = data;
        }
      })
      .addCase(getBranchListWithCity.rejected, (state, action) => {});

    builder
      .addCase(getBranchList.pending, (state) => {})
      .addCase(getBranchList.fulfilled, (state, action) => {
        const { success, data } = action.payload || {};
        if (success) {
          let activeData = (data || []).filter((branch) => branch.status == 1);
          state.branchesList = activeData;
        }
      })
      .addCase(getBranchList.rejected, (state, action) => {});

    builder
      .addCase(syncLocks.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(syncLocks.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(syncLocks.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default branchSlice.reducer;
export const { resetBranchesFilterState, updateBranchesFilterState } =
  branchSlice.actions;
